import React from 'react';
import { Box } from '@mui/material';
import OverviewHero from '../../components/overview/OverviewHero';
import OverviewExpertise from '../../components/overview/OverviewExpertise';
import OverviewEssence from '../../components/overview/OverviewEssence';
import OverviewCTA from '../../components/overview/OverviewCTA';

const OverviewDesktop = ({ engines, sectionTitle }) => (
  <Box sx={{ width: '100%', bgcolor: 'background.default', color: 'text.primary' }}>
    <OverviewHero />
    <OverviewExpertise engines={engines} sectionTitle={sectionTitle} />
    <OverviewEssence />
    <OverviewCTA />
  </Box>
);

export default OverviewDesktop;
